import React from 'react'
import { twMerge } from 'tailwind-merge'
import { DiagnosticsSummary } from '../hooks/use-diagnostics-summary'
import { Severity } from '../types'

interface SummaryBarProps {
  summary: DiagnosticsSummary
  activeFilter: Severity | null
  onFilterToggle: (severity: Severity) => void
}

const pillConfig: Array<{
  severity: Severity
  key: keyof Pick<DiagnosticsSummary, 'high' | 'warning' | 'info'>
  label: string
  baseClasses: string
  activeRing: string
}> = [
  {
    severity: 'high',
    key: 'high',
    label: 'High',
    baseClasses: 'bg-red-50 text-red-800',
    activeRing: 'border-red-500 shadow-[0_0_0_1px_#ef4444]',
  },
  {
    severity: 'warning',
    key: 'warning',
    label: 'Warning',
    baseClasses: 'bg-amber-50 text-amber-800',
    activeRing: 'border-amber-500 shadow-[0_0_0_1px_#f59e0b]',
  },
  {
    severity: 'info',
    key: 'info',
    label: 'Info',
    baseClasses: 'bg-blue-50 text-blue-800',
    activeRing: 'border-blue-500 shadow-[0_0_0_1px_#3b82f6]',
  },
]

export const SummaryBar = ({
  summary,
  activeFilter,
  onFilterToggle,
}: SummaryBarProps) => {
  return (
    <div className="flex shrink-0 items-center gap-2 border-gray-200 border-b bg-gray-50 px-4 py-1.5">
      {pillConfig.map(({ severity, key, label, baseClasses, activeRing }) => {
        const count = summary[key]
        if (count === 0) {
          return null
        }
        const isActive = activeFilter === severity
        return (
          <button
            key={severity}
            type="button"
            className={twMerge(
              'inline-flex cursor-pointer items-center rounded-xl border-[1.5px] border-transparent px-2.5 py-0.5 font-semibold text-xs leading-[18px]',
              baseClasses,
              isActive && activeRing,
            )}
            onClick={() => onFilterToggle(severity)}
            title={isActive ? 'Show all findings' : `Filter to ${label} only`}
          >
            {count} {label}
          </button>
        )
      })}
    </div>
  )
}
